/* eslint-disable */
import React, { createContext, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { settings } from '../config';
export const AuthContext = createContext(settings);

const AppProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [apiURL] = useState(process.env.REACT_APP_API_URL);
  const [apiURLKey] = useState(process.env.REACT_APP_CALL_PHP);
  const [codePanel, setCodePanel] = useState(false)
  const [username , setUsername] = useState(null);
  const [email, setEmail] = useState(null);
  const [resData, setResData] = useState(null);
  const [routeData, setRoutesData ] = useState(null);
  const [steps, setSteps] = useState(null);
  const [key, setKey] = useState(null);
  const [globalFlowId , setGlobalFlowId] = useState();
  const [cpDivs, setCpdivs] = useState([]);
  const [globalTabs, setGlobalTabs] = useState(null);
  const [routeClicked , setRouteClicked] = useState('');
  const [tabs, setTabs] = useState([])
  const [divT_Id, setDivT_Id] = useState('T1');
  const catchMouseUp = useRef(null);
  const catchMouseDown = useRef(null);
  const catchMouseMove = useRef(false);
  const handleColClick = async (selectedCol) => {
    const myCol = document.getElementById(selectedCol);
    // İşlemlerinizi burada gerçekleştirin
    setDivT_Id(selectedCol);
  };
  
  return (
    <AuthContext.Provider value={{
      isAuthenticated, 
      apiURL, 
      apiURLKey, 
      setIsAuthenticated,
      codePanel, 
      setCodePanel, 
      username, 
      setUsername, 
      setEmail, 
      email, 
      resData,
      routeData,
      steps,
      tabs,
      setTabs,
      key,
      setKey,
      setGlobalFlowId,
      cpDivs,
      setCpdivs,
      setGlobalTabs,
      globalTabs,
      routeClicked,
      setRouteClicked,
      setDivT_Id,
      divT_Id,
      handleColClick,
      catchMouseUp,
      catchMouseDown,
      catchMouseMove

      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AppProvider;
